/* eslint camelcase: 0 */  // snake_case query params are not set by us
require('es6-promise').polyfill();

const layers = q => `layers/${q}.json`;
const  data = q => `data/${q}.json`;

const get = url =>
  fetch(url).then(resp => resp.json());

export const getCoverage = () =>
	get(data('forestcoverage'));

export const getRegions = () =>
	get(layers('counties'));

export const getZones = () =>
	get(layers('zones'));

export const getBudget = () =>
	get(data('projects'));

export const getSpecies = () =>
	get(data('species'));



/** WEBPACK FOOTER **
 ** ./app/scripts/api.es6
 **/